import { gql } from '@apollo/client';

export interface IsTeamPickupWarehouseResponse {
    isTeamPickupWarehouse: boolean;
}

export interface IsTeamPickupWarehouseVariables {
    warehouseId: number;
    dspId: number;
}

export const IS_TEAM_PICKUP_WAREHOUSE = gql`
    query IsTeamPickupWarehouse($warehouseId: Long!, $dspId: Long!) {
        isTeamPickupWarehouse(warehouseId: $warehouseId, dspId: $dspId)
    }
`;